<template>
  <div>
    <!-- 同步笔记创建笔记 -->
    <el-dialog title="编辑笔记"
               :visible.sync="dialogFormVisible"
               width="1250px"
               top="30px"
               :close-on-click-modal="false"
               @close="emitCloses"
               @open="open()">
      <div class="diag">
        <!-- 左边一列 -->
        <div class="diagLeft">
          <p class="title">
            <span class="blue"></span>
            <span>笔记内容</span>
          </p>
          <div style="marginTop:10px">
            <el-form class="form"
                     :model="dataForm"
                     :rules="rules"
                     ref="dataForm"
                     label-width="70px">
              <el-form-item label="笔记类型"
                            label-width="70px">
                <el-select v-model="dataForm.note_type"
                           filterable
                           clearable
                           disabled
                           collapse-tags
                           placeholder="请选择"
                           style="width: 530px"
                           @change="selectChange">
                  <el-option v-for="(item, index) in  noteType"
                             :key="index"
                             :label="item.label"
                             :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="图片"
                            prop="avatar">
                <div class="upPictures">

                  <el-upload :action="imgUploadUrl"
                             drag
                             multiple
                             accept=".png,.jpg,.jpeg"
                             list-type="picture-card"
                             :on-preview="handlePictureCardPreview"
                             :on-remove="handleRemove"
                             :on-success="handleSuccess"
                             :file-list="fileList">
                    <i class="el-icon-plus"></i>
                  </el-upload>

                  <!-- <div class="textImage"
                       @click="handleTextImage()">

                    <div>
                      文生图<i class="el-icon-plus"></i>
                    </div>
                  </div> -->

                </div>
              </el-form-item>

              <el-form-item label="标题名称"
                            prop="avatar"
                            label-width="70px">
                <el-input v-model="dataForm.name"
                          type="text"
                          placeholder="请输入内容"
                          @paste.native="handlePaste($event, index)"></el-input>
              </el-form-item>
              <el-form-item label="正文内容"
                            prop="avatar"
                            label-width="70px">
                <VueEditor :content="dataForm.detail"
                           placeholder="这个是文章内容编辑区域，如果是转载内容，请著名转载，标注好侵权及删的声明。"
                           @change="contentChange" />
              </el-form-item>
              <el-form-item label="关联院校"
                            label-width="70px">
                <el-select v-model="dataForm.topic_college_code"
                           filterable
                           clearable
                           collapse-tags
                           placeholder="请选择"
                           @change="collegeChange"
                           style="width: 530px">
                  <el-option v-for="(item, index) in $store.state.collegeList"
                             :key="index"
                             :label="item.name"
                             :value="String(item.code)">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="关联专业"
                            label-width="70px">
                <el-select v-model="dataForm.topic_major_code"
                           filterable
                           clearable
                           collapse-tags
                           placeholder="请选择"
                           @change="majorChange"
                           style="width: 530px">
                  <el-option v-for="(item, index) in majorList"
                             :key="index"
                             :label="item.name"
                             :value="item.code">
                    <span>{{ `（${item.code}）${item.name}` }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="关联科目"
                            label-width="70px">
                <el-select v-model="dataForm.test_subject_code"
                           clearable
                           filterable
                           placeholder="请选择"
                           style="width: 530px"
                           @change="handleSubject">
                  <el-option v-for="(item, index) in subjectsList"
                             :key="index"
                             :label="item.subject_name"
                             :value="item.subject_code">
                    <span>{{
                    `（${item.subject_code}）${item.subject_name}`
                  }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </div>

        <div class="diagLeft"
             style="marginLeft:40px;width:400px">
          <el-form class="form"
                   :model="dataForm"
                   :rules="rules"
                   ref="dataForm"
                   label-width="40px">
            <el-form-item :label="getTitle()"
                          v-if="dataForm.note_type=='6'||dataForm.note_type=='7'"
                          prop="avatar"
                          label-width="110px">
              <el-radio-group v-model="dataForm.datumType"
                              @change="radioDatumChange"
                              v-if="dataForm.note_type=='6'">
                <el-radio class="input-radio"
                          :label="1">
                  资料
                </el-radio>
                <el-radio class="input-radio"
                          :label="2">
                  网盘
                </el-radio>
              </el-radio-group>

              <el-upload :action="getUrl()"
                         accept=".pdf,.mp4"
                         :headers="uploadFileHeaders"
                         :on-success="handleUploadSuccess"
                         :file-list="fileuploadList"
                         :on-exceed="handleUploadOnExeed"
                         :on-remove="handleUploadRemove"
                         v-if="dataForm.datumType==1">
                <el-button size="mini"
                           type="primary"
                           v-if="dataForm.datumType==1">上传文件</el-button>
              </el-upload>
              <div v-if="dataForm.datumType==2">
                <div style="display:flex;marginBottom:10px;justify-content: space-between;"> <span class="name">名称：</span><el-input v-model="dataForm.file_name"
                            placeholder="请输入文件名称"
                            style="width:220px"></el-input></div>
                <div style="display:flex;marginBottom:10px;justify-content: space-between;"> <span class="name">链接：</span> <el-input v-model="dataForm.download_url"
                            placeholder="请输入网盘链接"
                            style="width:220px"></el-input></div>
                <div style="display:flex;marginBottom:10px;justify-content: space-between;"> <span class="name">提取码：</span> <el-input v-model="dataForm.extract_code"
                            placeholder="请输入提取码"
                            style="width:220px"></el-input></div>
                <div style="display:flex;marginBottom:10px;justify-content: space-between;"><span class="name">网盘类型：</span><el-select v-model="dataForm.disk_type"
                             clearable
                             filterable
                             placeholder="请选择"
                             style="width: 220px">
                    <el-option v-for="(item, index) in netWorkList"
                               :key="index"
                               :label="item.label"
                               :value="item.id">
                      <span>{{
                    `（${item.label}）`
                  }}</span>
                    </el-option>
                  </el-select></div>
                <div style="width:400px"> <span class="name">有效期：</span><el-radio-group v-model="dataForm.expire_time">
                    <el-radio class="input-radio"
                              :label="7">
                      7天
                    </el-radio>
                    <el-radio class="input-radio"
                              :label="30">
                      30天
                    </el-radio>
                    <el-radio class="input-radio"
                              :label="0">
                      永久有效
                    </el-radio>
                  </el-radio-group></div>
              </div>
            </el-form-item>
            <el-form-item label="付费查看"
                          prop="avatar"
                          label-width="110px"
                          v-if="(dataForm.note_type=='6'&&dataForm.datumType==1)||dataForm.note_type=='7'">
              <el-switch v-model="dataForm.status"></el-switch> <span v-if="dataForm.status">售价：<span style="color:red">￥{{getPrice()}}</span></span>
            </el-form-item>
            <el-form-item label="关联赠送答疑卡"
                          label-width="110px">
              <el-select v-model="dataForm.receive_answer_card_type"
                         clearable
                         placeholder="请选择"
                         style="width: 360px"
                         @change="selectCard()">
                <el-option v-for="(item, index) in answerCard"
                           :key="index"
                           :label="item.label"
                           :value="item.id">
                  <span>{{
                    `${item.label}`
                  }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="答疑老师"
                          label-width="110px">
              <el-select v-model="dataForm.receive_answer_uid"
                         clearable
                         filterable
                         placeholder="请选择"
                         style="width: 360px">
                <el-option v-for="(item, index) in noteSeniorList"
                           :key="index"
                           :label="`${item.nickname}（${item.mobile}）`"
                           :value="item.id">
                  <span>
                    <span>{{ `${item.nickname}（${item.mobile}）` }}</span>
                  </span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="发布人"
                          label-width="110px">
              <el-radio-group v-model="dataForm.type"
                              @change="radioChange">
                <el-radio class="input-radio"
                          :label="1">
                  用户
                </el-radio>
                <el-radio class="input-radio"
                          :label="2">
                  虚拟用户
                </el-radio>
              </el-radio-group>
              <div v-if="virtUser.length>0">
                <el-tag v-for="tag in virtUser"
                        :key="tag.name"
                        closable>
                  {{tag.nickname}}{{tag.mobile ?tag.mobile:''}}
                </el-tag>
              </div>
              <div v-if="realUser.length>0">
                <el-tag v-for="tag in realUser"
                        :key="tag.name"
                        closable>
                  {{tag.nickname}}/{{tag.mobile ?tag.mobile :''}}
                </el-tag>
              </div>
            </el-form-item>
            <el-form-item label="发布时间"
                          label-width="110px">
              <el-date-picker v-model="dataForm.admin_finger_publish_time"
                              type="datetime"
                              style="width: 360px"
                              format="yyyy-MM-dd HH:mm"
                              value-format="timestamp"
                              placeholder="选择日期时间" />
              <div class="timeGroup">
                <div v-for="range in timeRanges"
                     :key="range.id"
                     @click="handleRangeSelect(range)">
                  <span class="timeItem"> {{ range.label }}</span> <span v-if="range.id !=5">|</span>
                </div>
              </div>
            </el-form-item>
          </el-form>

          <div class="footer">
            <div class="cancle"
                 @click="emitCloses()">取消</div>

            <div class="confirm"
                 @click="submit()">确定</div>
          </div>
        </div>

      </div>
    </el-dialog>
    <Virtualuser :isVisible="VirtualVisible"
                 :isStudent="isStudent"
                 @close="handleClose()"
                 @virtChoose="virtChoose" />
    <Realname :isVisible="realUserVisible"
              @close="handleUserClose()"
              @realChoose="realChoose"
              :note_type="note_type" />
    <TextImage :isVisible="textVisible"
               @close="closeText" />

  </div>
</template>
<script>
// import { notePut } from '@/api/read.js'
import { noteUserList, seniorOne, noteDetail, notePut } from '@/api/senior.js'
import {
  imgUploadUrl,
  uploadHeaders,
  fileUploadUrl,
  uploadFileHeaders,
} from '@/config/index'
import VueEditor from '@/components/VueEditor'
import { collegeMajorList, majorSubjectList, majorList } from '@/api/common'
import Virtualuser from '@/components/dialog/virtualUser'
import Realname from '@/components/dialog/realnameUser'

import TextImage from '@/components/dialog/textToImage/textToImage.vue'

export default {
  components: { VueEditor, Virtualuser, Realname, TextImage },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    product_ids: {
      type: Number,
      default: () => {
        return null
      },
    },
    title: {
      type: String,
      default: () => {
        return ''
      },
    },
    rowId: {
      type: Number,
      default: () => {
        return null
      },
    },
  },
  data() {
    return {
      note_type: '',
      upTitle: '',
      titles: '',
      dataForm: {
        datumType: 1,
        name: '',
        status: false,
        topic_college_code: '',
        topic_college_name: '',
        topic_major_code: '',
        topic_major_name: '',
        topic_subject_code: '',
        topic_subject_name: '',
        receive_answer_uid: '',
        receive_answer_card_type: '',
        type: '',
        admin_finger_publish_time: null,
        file_name: '',
        disk_type: 1,
        download_url: '',
        extract_code: '',
        expire_time: 0,
      },
      answerCard: [
        {
          id: '1',
          label: '周卡',
        },
        {
          id: '2',
          label: '月卡',
        },
        {
          id: '3',
          label: '季卡',
        },
      ],
      noteType: [
        {
          id: '1',
          label: '求解答',
        },
        {
          id: '2',
          label: '求资料',
        },
        {
          id: '3',
          label: '求课程',
        },
        {
          id: '4',
          label: '经验',
        },
        {
          id: '5',
          label: '看法',
        },
        {
          id: '6',
          label: '资料',
        },
        {
          id: '7',
          label: '视频',
        },
      ],
      netWorkList: [
        {
          id: 1,
          label: '夸克网盘',
        },
        {
          id: 2,
          label: '百度网盘',
        },
        {
          id: 3,
          label: '其他网盘',
        },
      ],
      dialogFormVisible: this.isVisible,
      VirtualVisible: false,
      realUserVisible: false,
      textVisible: false,
      detailPdf: [],
      rules: {},
      imgUploadUrl: imgUploadUrl(),
      uploadHeaders: uploadHeaders(),
      uploadFileHeaders: uploadFileHeaders(),
      fileList: [],
      fileuploadList: [],
      academyList: [],
      majorList: [],
      subjectsList: [],
      noteSeniorList: [],
      virtUser: [],
      realUser: [],
      // 1. 定义时间范围选项
      timeRanges: [
        { id: 1, label: '0-1小时前', minHours: 0, maxHours: 1 },
        { id: 2, label: '1-3小时前', minHours: 1, maxHours: 3 },
        { id: 3, label: '3-6小时前', minHours: 3, maxHours: 6 },
        { id: 4, label: '6-12小时前', minHours: 6, maxHours: 12 },
        { id: 5, label: '12-24小时前', minHours: 12, maxHours: 24 },
      ],
      // 响应式变量，用于存储当前选中的范围和计算结果
      selectedRange: null,
      timeResult: null,
      configureList: [],
      isStudent: '',
      note_id: null,
      uid: null,
    }
  },
  watch: {
    isVisible(val) {
      this.dialogFormVisible = val
    },
  },
  methods: {
    handlePaste(value, num) {
      if (this.fileList.length >= 9) {
        this.$message.error('最多可以传九张')
        return
      }
      let file = value.clipboardData.items[0]

      if (file.type.includes('image')) {
        let imgFile = file.getAsFile()
        const formData = new FormData()
        formData.append('file', imgFile)
        const axiosInstance = this.$axios.create({ withCredentials: false })
        axiosInstance({
          method: 'post',
          url: this.imgUploadUrl, // 上传地址，视情况更换
          data: formData,
        })
          .then((res) => {
            // 调用成功回调
            this.fileList.push({
              url: res.data.data.url,
            })
          })
          .catch(function (err) {
            console.log(err)
            // 上传失败
          })
      }
    },
    getDetail() {
      noteDetail({ id: this.rowId }).then((res) => {
        if (res) {
          this.note_id = res.id
          this.uid = res.author_user_obj.id
          this.fileList = []
          res.media_img_urls.split(',').map((item) => {
            this.fileList.push({
              url: item,
            })
          })
        }
        if (res.topic_college_code) {
          this.$set(this.dataForm, 'topic_college_code', res.topic_college_code)
          this.$set(this.dataForm, 'topic_college_name', res.topic_college_name)
        }
        if (res.topic_major_code) {
          this.$set(this.dataForm, 'topic_major_code', res.topic_major_code)
          this.$set(this.dataForm, 'topic_major_name', res.topic_major_name)
        }
        if (res.topic_subject_code != '') {
          this.$set(this.dataForm, 'topic_subject_code', res.topic_subject_code)
          this.$set(this.dataForm, 'topic_subject_name', res.topic_subject_name)
        }
        if (
          res.topic_college_code != '' &&
          res.topic_college_code != undefined
        ) {
          this.getCollegeMajor()
        } else {
          this.getMajor(res.topic_college_code)
        }
        this.$set(
          this.dataForm,
          'status',
          res.receive_fee_status == 0 ? false : true
        )

        this.dataForm.note_type = res.note_type + ''
        this.dataForm.name = res.title
        this.dataForm.detail = res.content_text
        if (res.arr_extend_pdf_obj && res.arr_extend_pdf_obj.length > 0) {
          this.fileuploadList = []
          res.arr_extend_pdf_obj.map((item) => {
            this.fileuploadList.push({
              url: '',
              name: item.pdf_name,
              resource_id: item.note_pdf_resource_id,
              status: 'success', // 标记状态为成功
            })
          })
        }
        if (res.media_video_url != '') {
          this.fileuploadList = []
          this.fileuploadList.push({
            url: res.media_video_url,
            name: '视频',
          })
        }
        if (res.receive_answer_card_type != 0) {
          this.dataForm.receive_answer_card_type =
            res.receive_answer_card_type + ''
          this.dataForm.receive_answer_uid = res.receive_answer_uid
        }
        if (res.net_disk_obj != null) {
          this.dataForm.datumType = 2
          this.$set(this.dataForm, 'disk_type', res.net_disk_obj.disk_type * 1)
          this.$set(this.dataForm, 'file_name', res.net_disk_obj.file_name)
          this.$set(
            this.dataForm,
            'download_url',
            res.net_disk_obj.download_url
          )
          this.$set(
            this.dataForm,
            'extract_code',
            res.net_disk_obj.extract_code
          )
          this.$set(
            this.dataForm,
            'expire_time',
            res.net_disk_obj.expire_time / 24 / 60 / 60 / 1000
          )
          console.log('expire_time', this.dataForm.expire_time)
        } else {
          this.dataForm.datumType = 1
        }
        this.realUser = []
        this.realUser.push({
          id: res.author_user_obj.id,
          nickname: res.author_user_obj.nickname,
          mobile: res.author_user_obj.mobile,
        })
        this.$set(this.dataForm, 'admin_finger_publish_time', res.update_time)
      })
    },
    radioDatumChange(e) {
      this.dataForm.datumType = e
    },
    selectChange(e) {
      if (e == 1 || e == 2 || e == 3) {
        this.isStudent = '学生'
      }
      if (e == 4 || e == 5 || e == 6 || e == 7) {
        this.isStudent = '学长'
      }
    },
    // 关联科目
    remoteMethod(query) {},
    getLimit() {
      if (this.dataForm.note_type == '7' || this.dataForm.note_type == '6') {
        return '1'
      } else {
        return '9'
      }
    },
    getUrl() {
      // https://test-api.kaoyanbox.net/api/v1/back/upload/private/byNotePdf
      if (this.dataForm.note_type == '6') {
        return location.host.includes('admin.kaoyanbox.com')
          ? 'https://api.kaoyanbox.com/api/v1/back/upload/private/byNotePdf'
          : 'https://test-api.kaoyanbox.net/api/v1/back/upload/private/byNotePdf'
      } else if (this.dataForm.note_type == '7') {
        return location.host.includes('admin.kaoyanbox.com')
          ? 'https://api.kaoyanbox.com/api/v1/back/back/upload/vod/video'
          : 'https://test-api.kaoyanbox.net/api/v1/back/upload/vod/video'
      }
    },
    getTitle() {
      if (this.dataForm.note_type == '6') {
        return '添加资料'
      } else if (this.dataForm.note_type == '7') {
        return '添加视频'
      }
    },
    closeText() {
      this.textVisible = false
    },
    // 2. 核心方法：处理时间范围选择
    handleRangeSelect(range) {
      // 更新选中的范围
      this.selectedRange = range
      // 从选中的范围对象中获取小时数的上下限
      const { minHours, maxHours, label } = range
      // 生成 [minHours, maxHours] 之间的一个随机整数
      //  const randomHours = Math.floor(Math.random() * (maxHours - minHours + 1)) + minHours;
      const randomHours = Math.random() * (maxHours - minHours) + minHours
      // 获取当前时间的时间戳 (毫秒)
      const nowTimestamp = Date.now()
      // 计算目标时间的时间戳
      // 1小时 = 3600000 毫秒
      const targetTimestamp = nowTimestamp - randomHours * 3600000

      // 将目标时间戳格式化为易读的字符串
      const targetTimeString = new Date(targetTimestamp).toLocaleString()

      // 将所有结果存入 result 对象，用于在模板中展示
      this.timeResult = {
        selectedLabel: label,
        randomHours: randomHours,
        timestamp: Math.floor(targetTimestamp),
        targetTimeString: targetTimeString,
      }
      this.$set(
        this.dataForm,
        'admin_finger_publish_time',
        this.timeResult.timestamp
      )
    },
    virtChoose(val) {
      this.virtUser = val
    },
    realChoose(val) {
      this.realUser = val
    },
    emitCloses() {
      this.fileList = []
      this.fileuploadList = []
      this.virtUser = []
      this.realUser = []
      this.selectedRange = null
      this.timeResult = null
      this.dataForm = {
        name: '',
        status: false,
        topic_college_code: '',
        topic_college_name: '',
        topic_major_code: '',
        topic_major_name: '',
        topic_subject_code: '',
        topic_subject_name: '',
        receive_answer_uid: '',
        receive_answer_card_type: '',
        type: '',
        admin_finger_publish_time: null,
        file_name: '',
        datumType: 1,
        download_url: '',
        extract_code: '',
        expire_time: 0,
        disk_type: 0,
      }
      this.dialogFormVisible = false
      this.$emit('Editclose')
    },
    handleClose() {
      this.VirtualVisible = false
    },
    handleUserClose() {
      this.realUserVisible = false
    },

    // 获取笔记用户
    getNoteUser() {
      noteUserList({
        user_education_type: 2,
        isPaging: 0,
        // pageSize: 20,
        // pageIndex: 1,
      }).then((res) => {
        this.noteSeniorList = res.list
      })
    },

    open() {
      this.getDetail()
      this.getMajor(this.dataForm.topic_college_code)
      this.getNoteUser()
    },
    //获取专业
    getMajor() {
      let data = {
        combine: 0,
        level: 3,
        isPaging: 0,
      }

      majorList(data).then((res) => {
        this.majorList = res.list || []
        this.getSubjectsByMajorCode(
          this.dataForm.topic_college_code,
          this.dataForm.topic_major_code,
          false
        )
      })
    },
    // 如果有院校添加院校筛选
    getCollegeMajor() {
      let data = {
        isPaging: 0,
        college_code: this.dataForm.topic_college_code,
      }
      collegeMajorList(data).then((res) => {
        this.majorList = res.list || []
        this.getSubjectsByMajorCode(
          this.dataForm.topic_college_code,
          this.dataForm.topic_major_code,
          false
        )
      })
    },
    //获取科目
    getSubjectsByMajorCode(college_code, major_code, isAll) {
      let query = {}
      if (!isAll) {
        query = {
          pageIndex: 1,
          pageSize: 200,
          college_code: college_code,
          major_code: major_code,
        }
      } else {
        query = {
          college_code: college_code,
          major_code: major_code,
        }
      }
      majorSubjectList(query).then((res) => {
        this.subjectsList = res.list || []
      })
    },
    handleSubject(e) {
      this.dataForm.test_subject_name = this.subjectsList.find((item) => {
        return item.subject_code === e //筛选出匹配数据
      }).subject_name
    },
    collegeChange(e) {
      this.dataForm.topic_major_code = ''
      this.dataForm.topic_major_name = ''
      this.dataForm.topic_college_name = this.$store.state.collegeList.find(
        (item) => {
          return item.code === e //筛选出匹配数据
        }
      ).name
      this.getCollegeMajor()
    },
    majorChange(e) {
      this.dataForm.topic_subject_code = ''
      this.dataForm.topic_subject_name = ''
      this.dataForm.topic_major_name = this.majorList.find((item) => {
        return item.code === e //筛选出匹配数据
      }).name
      this.getSubjectsByMajorCode(
        this.dataForm.topic_college_code,
        this.dataForm.topic_major_code,
        false
      )
    },
    handlePictureCardPreview() {},
    handleRemove() {},
    handleSuccess(response, file, fileList) {
      this.fileList = fileList.map((item) => {
        if (item.response) {
          return item.response.data
        } else {
          return item
        }
      })
    },
    handleUploadOnExeed() {},
    handleUploadRemove(e) {
      this.fileuploadList = this.fileuploadList.filter((v) => {
        return e.resource_id != v.resource_id
      })
    },
    handleUploadSuccess(res, file) {
      if (this.dataForm.note_type == '6') {
        this.fileuploadList.push({
          name: file.name.slice(0, -4),
          url: file.response.data.pdf_temp_preview_url,
          resource_id: file.response.data.note_pdf_resource_id,
          status: 'success', // 标记状态为成功
        })
      } else if (this.dataForm.note_type == '7') {
        this.fileuploadList.push({
          name: file.name.slice(0, -4),
          url: file.response.data.vod_temp_preview_url,
          resource_id: file.response.data.vod_video_id,
          status: 'success', // 标记状态为成功
        })
      }
    },
    contentChange(e) {
      this.dataForm.detail = e.html
    },
    handleTextImage() {
      this.textVisible = true
    },
    radioChange(e) {
      if (e == 2) {
        this.VirtualVisible = true
        this.realUser = []
      } else if (e == 1) {
        this.realUserVisible = true
        this.virtUser = []
        this.note_type = this.dataForm.note_type
      }
      this.dataForm.type = e
    },
    getPrice() {
      // location.host.includes('admin.kaoyanbox.com'）
      if (this.detailPdf.length < 3 || this.detailPdf.length == 3) {
        return 9.9
        // return location.host.includes('test') ? '0.01' : '9.9'
      } else if (this.detailPdf.length > 3 && this.detailPdf.length < 7) {
        return 19.9
        // return location.host.includes('test') ? '0.02' : '19.9'
      } else if (this.detailPdf.length == 7 || this.detailPdf.length > 7) {
        // return location.host.includes('test') ? '0.03' : '29.9'
        return 29.9
      }
    },
    //调取学长详情
    getSeniorDetail(id) {
      seniorOne({ id: id }).then((res) => {
        let nameItem = this.noteSeniorList.filter((v) => {
          return v.id == res.uid
        })
        this.dataForm.receive_answer_uid = nameItem[0].id
      })
    },
    selectCard() {
      if (this.dataForm.receive_answer_card_type == '') {
        this.dataForm.receive_answer_uid = ''
      }
    },
    submit() {
      if (this.dataForm.note_type == undefined) {
        this.$message.error(`请选择笔记类型`)
        return
      }
      if (this.fileuploadList.length == 0) {
        if (this.dataForm.note_type == '6') {
          if (this.dataForm.datumType == 1) {
            this.$message.error(`请上传资料`)
            return
          } else {
            if (this.dataForm.file_name == '') {
              this.$message.error(`请输入网盘名称`)
              return
            }
            if (this.dataForm.download_url == '') {
              this.$message.error(`请输入网盘地址`)
              return
            }
            if (this.dataForm.extract_code == '') {
              this.$message.error(`请输入提取码`)
              return
            }
            if (this.dataForm.file_name == '') {
              this.$message.error(`请输入网盘名称`)
              return
            }
          }
        } else if (this.dataForm.note_type == '7') {
          this.$message.error(`请上传视频`)
          return
        }
      }
      if (this.fileList.length == 0) {
        this.$message.error(`请选择图片`)
        return
      }
      if (this.dataForm.name == '') {
        this.$message.error(`请填写标题名称`)
        return
      }
      if (this.dataForm.detail == '') {
        this.$message.error(`请填写正文`)
        return
      }

      if (
        this.dataForm.receive_answer_card_type &&
        (this.dataForm.receive_answer_uid == '' ||
          this.dataForm.receive_answer_uid == undefined)
      ) {
        this.$message.error(`请选择答疑老师`)
        return
      }

      if (this.virtUser.length == 0 && this.realUser == 0) {
        this.$message.error(`请选择发布人`)
        return
      }
      let data = {
        id: this.note_id,
        uid: this.uid,
        receive_fee_status: this.dataForm.status == true ? 1 : 0,
        extend_pdf_store_type: 2,
        fix_receive_name_status: 1,
        fix_receive_price_status: 1,
        sync_receive_content_status: 1,
        title: this.dataForm.name,
        media_img_urls: this.fileList.map((item) => item.url).join(','),
        content_text: this.dataForm.detail,
        topic_college_code: this.dataForm.topic_college_code,
        topic_college_name: this.dataForm.topic_college_name,
        topic_major_code: this.dataForm.topic_major_code,
        topic_major_name: this.dataForm.topic_major_name,
        topic_subject_code: this.dataForm.test_subject_code,
        topic_subject_name: this.dataForm.test_subject_name,
        receive_answer_card_type: this.dataForm.receive_answer_card_type,
        receive_answer_uid: this.dataForm.receive_answer_uid,
        cover_img_url: this.fileList.map((item) => item.url)[0],
        admin_finger_publish_time: this.dataForm.admin_finger_publish_time,
      }

      if (this.dataForm.receive_answer_card_type) {
        data.receive_present_answer_status = 1
      }

      //  上传资料
      // if (this.fileuploadList.length > 0) {
      if (this.dataForm.note_type == '6') {
        if (this.dataForm.datumType == 1) {
          let arr_extend_pdf_obj = []
          this.fileuploadList.map((item) => {
            arr_extend_pdf_obj.push({
              note_pdf_resource_id: item.resource_id,
              pdf_name: item.name,
            })
          })
          data.arr_extend_pdf_obj = arr_extend_pdf_obj
        } else {
          data.net_disk_obj = {
            file_name: this.dataForm.file_name,
            download_url: this.dataForm.download_url,
            extract_code: this.dataForm.extract_code,
            disk_type: this.dataForm.disk_type,
          }
          if (this.dataForm.expire_time == 0) {
            data.net_disk_obj.expire_time = 0
          } else {
            const currentTimeStamp = Date.now() // 或者 new Date().getTime()
            const sevenDaysInMs =
              this.dataForm.expire_time * 24 * 60 * 60 * 1000
            const nextWeekTimeStamp = currentTimeStamp + sevenDaysInMs
            data.net_disk_obj.expire_time = nextWeekTimeStamp
          }
        }
      } else if (this.dataForm.note_type == '7') {
        let arr_vod_video_obj = []
        this.fileuploadList.map((item) => {
          arr_vod_video_obj.push({
            video_id: item.resource_id,
            video_name: item.name,
          })
        })
      }
      // }

      if (this.dataForm.type == 2) {
        data.admin_finger_uid = this.virtUser[0].uid
      } else if (this.dataForm.type == 1) {
        data.admin_finger_uid = this.realUser[0].uid
      }

      notePut(data)
        .then((res) => {
          console.log('res44', res)
          if (res == null) {
            this.emitCloses()
            this.$message.success(`修改成功`)
          }
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
  },
}
</script>
<style  lang="less" scoped>
::v-deep .el-dialog__header {
  background: #ebeef5;
}
::v-deep .el-upload-dragger {
  width: 90px;
  height: 90px;
}
::v-deep .el-upload--picture-card {
  width: 90px;
  height: 90px;
}
::v-deep .upPictures .el-upload-list__item {
  width: 90px;
  height: 90px;
}
.upPictures {
  position: relative;
  .textImage {
    position: absolute;
    top: 0px;
    left: 100px;
    text-align: center;
    width: 90px;
    height: 90px;
    line-height: 90px;
    font-size: 10px;
    color: rgba(0, 0, 0, 0.4);
    background: #eeeeee;
    border-radius: 0px 0px 0px 0px;
    border: 1px solid #dcdcdc;
  }
}
.name {
  display: inline-block;
  text-align: right;

  width: 70px;
}

.diag {
  display: flex;
  .diagLeft {
    width: 600px;
    .title {
      display: flex;
      font-size: 14px;
      color: #303133;

      .blue {
        margin-right: 8px;
        display: inline-block;
        width: 4px;
        height: 14px;
        background: #409eff;
        border-radius: 4px 4px 4px 4px;
      }
    }
    .timeGroup {
      width: 380px;
      height: 40px;
      display: flex;
      justify-content: space-between;

      .timeItem {
        color: #409eff;
        cursor: pointer;
      }
    }
    .footer {
      width: 120px;
      float: right;
      display: flex;
      margin-right: -70px;
      .cancle {
        font-weight: 400;
        font-size: 14px;
        color: #909399;
        width: 56px;
        text-align: center;
        height: 36px;
        line-height: 36px;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #dcdfe6;
        margin-right: 20px;
      }
      .confirm {
        text-align: center;
        width: 56px;
        height: 36px;
        font-size: 14px;
        color: #ffffff;
        line-height: 36px;
        background: #409eff;
        border-radius: 4px 4px 4px 4px;
      }
    }
  }
  .diagRight {
  }
}
</style>